<div class="gallery-content-card"
     [class.micro]="sizeCard === eSizeCard.micro"
     [class.mid]="sizeCard === eSizeCard.mid"
     [class.normal]="sizeCard === eSizeCard.normal"
     (click)="onOpenCard()">
  <img *ngIf="coverImgUrl" [src]="coverImgUrl" [alt]="title" class="cover">
</div>
